import { apiClientKey } from '../../services/storageNamespace';

// ═══════════════════════════════════════════════════════════════════════════════
// Teams list cache (stale-while-revalidate)
// ═══════════════════════════════════════════════════════════════════════════════
export const teamsCacheKey = () => apiClientKey('teams-cache');

export function getTeamsCache() {
  try {
    const raw = localStorage.getItem(teamsCacheKey());
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function saveTeamsCache(teams, uniqueMembers) {
  try {
    localStorage.setItem(teamsCacheKey(), JSON.stringify({ teams, uniqueMembers }));
  } catch {}
}

export const TEAM_DETAIL_CACHE_KEY = id => apiClientKey(`team-detail-${id}`);

export function getTeamDetailCache(teamId) {
  try {
    const raw = localStorage.getItem(TEAM_DETAIL_CACHE_KEY(teamId));
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}

export function saveTeamDetailCache(teamId, partial) {
  try {
    const prev = getTeamDetailCache(teamId) || {};
    localStorage.setItem(TEAM_DETAIL_CACHE_KEY(teamId), JSON.stringify({ ...prev, ...partial }));
  } catch {}
}

export function invalidateTeamDetailWorkspacesCache(teamId) {
  if (teamId == null) return;
  try {
    const prev = getTeamDetailCache(teamId);
    if (!prev?.workspaces) return;
    const { workspaces: _workspaces, ...rest } = prev;
    if (Object.keys(rest).length === 0) {
      localStorage.removeItem(TEAM_DETAIL_CACHE_KEY(teamId));
    } else {
      localStorage.setItem(TEAM_DETAIL_CACHE_KEY(teamId), JSON.stringify(rest));
    }
  } catch {}
}

// ═══════════════════════════════════════════════════════════════════════════════
// Main component
// ═══════════════════════════════════════════════════════════════════════════════
export const TABS = ['Overview','Members','Workspaces','Boards','Activity'];

// Vault sits next to Boards, before Activity — Activity is a log, so it reads
// last, after the surfaces you actually manage.
export const VAULT_TAB_AFTER = 'Boards';

/**
 * The Vault tab is appended only for someone the SERVER says may administer
 * this team's grants (`can_administer` on GET /vault/folders). Not derived from
 * the role string here: roles in this codebase have no enum and no check
 * constraint, two different validation lists and a legacy `member` value, so a
 * client-side re-derivation is how the two sides come to disagree. Absent until
 * the fetch lands, which is the right default — a tab that appears and then
 * refuses every action is worse than one that appears a beat late.
 */
export const VAULT_TAB = 'Vault';

export function tabsForTeam(canAdministerVault) {
  if (!canAdministerVault) return TABS;
  const at = TABS.indexOf(VAULT_TAB_AFTER) + 1;
  return [...TABS.slice(0, at), VAULT_TAB, ...TABS.slice(at)];
}
